import AppCookieProvider from '@providers/AppCookieProvider';
import AppCustomProvider from '@providers/AppCustomProvider';
import AppQueryProvider from '@providers/AppQueryProvider';
import ColorProvider from '@providers/ColorProvider';
import GoogleLoginProvider from '@providers/GoogleLoginProvider';
import LanguageProvider from '@providers/LanguageProvider';
import UserProvider from '@providers/UserProvider';
import { store } from '@store/store';
import { ReactNode } from 'react';
import { Provider } from 'react-redux';

interface Props {
    children: ReactNode;
}

function AppProvider({ children }:Props) {
    return (
        <AppCookieProvider>
            <AppQueryProvider>
                <Provider store={store}>
                    <GoogleLoginProvider>
                        <ColorProvider>
                            <AppCustomProvider>
                                <LanguageProvider>
                                    <UserProvider>
                                        {children}
                                    </UserProvider>
                                </LanguageProvider>
                            </AppCustomProvider>
                        </ColorProvider>
                    </GoogleLoginProvider>
                </Provider>
            </AppQueryProvider>
        </AppCookieProvider>
    );
}

export default AppProvider;
